export function UserIcon({
  className = "size-5",
}: {
  className?: string;
}) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g clip-path="url(#clip0_2967_30801)">
        <path d="M4.43025 16.1987C4.93718 15.0043 6.12077 14.1667 7.5 14.1667H12.5C13.8792 14.1667 15.0628 15.0043 15.5698 16.1987M13.3333 7.91667C13.3333 9.75762 11.8409 11.25 10 11.25C8.15905 11.25 6.66667 9.75762 6.66667 7.91667C6.66667 6.07572 8.15905 4.58333 10 4.58333C11.8409 4.58333 13.3333 6.07572 13.3333 7.91667ZM18.3333 10C18.3333 14.6024 14.6024 18.3333 10 18.3333C5.39763 18.3333 1.66667 14.6024 1.66667 10C1.66667 5.39763 5.39763 1.66667 10 1.66667C14.6024 1.66667 18.3333 5.39763 18.3333 10Z" stroke="#101828" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_2967_30801">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
export const displayName = "UserIcon";
